export default "__VITE_ASSET__DK500nfr__"